import { useEffect, useState } from 'react';
import { MdKeyboardArrowDown } from 'react-icons/md';

import CategoryStore from '../../store/categories';
import CategoriesModal from '../CategoriesModal/CategoriesModal';
import FavoriteAside from '../FavoritesAside/FavoritesAside';

import styles from './CategoriesSelect.module.scss';

export default function CategoriesSelect({ slug }) {
  const [showCategories, setShowCategories] = useState(false);
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState([]);

  useEffect(() => {
    const categories$ = CategoryStore.subscribe(setCategories);

    return () => {
      categories$.unsubscribe();
    };
  }, []);

  useEffect(() => {
    const currentCategory = categories.find(_category => _category.slugAscii === slug[0]);
    setCategory(currentCategory);
  }, [categories]);

  useEffect(() => {
    if (showCategories) {
      setShowCategories(false);
    }
  }, [slug]);

  return (
    <section className={styles.showOnSmallScreen}>
      <div className={styles.container}>
        <button type="button" className={styles.categoriesBtn} onClick={() => setShowCategories(!showCategories)}>
          <p>Κατηγορίες προϊόντων</p>
          <MdKeyboardArrowDown className={styles.arrowIcon} alt="άνοιγμα κατηγορίων" />
        </button>
        <FavoriteAside />
      </div>
      <CategoriesModal isOpen={showCategories} setIsOpen={setShowCategories} slug={slug} category={category} />
    </section>
  );
}
